import { render, staticRenderFns } from "./AuditDashboard.vue?vue&type=template&id=84937f2a"
import script from "./AuditDashboard.vue?vue&type=script&lang=js"
export * from "./AuditDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports